module.exports = __webpack_public_path__ + "src/assets/textures/cow/Cow_Albedo_2_1k.png";